<nz-table
  #basicTable
  [nzShowPagination]="options.showPagination"
  [nzShowSizeChanger]="options.showPageSizeChanger"
  [nzData]="data"
  [nzBordered]="true"
  [nzSize]="'middle'"
  [nzTotal]="data?.length"
  [nzPageSize]="options.pageSize"
  [nzPageIndex]="pageIndex"
  (nzPageSizeChange)="onPageSizeChange($event)"
  (nzPageIndexChange)="onPageIndexChange($event)"
>
  <thead>
    <tr>
      <ng-container *ngFor="let column of columns">
        <!-- Dynamically render the header columns -->
        @if(column.key === 'row_expand'){
        <th scope="col" nzWidth="20px" [ngStyle]="column.headerStyles"></th>
        } @if(column.key === 'token_copy'){
        <th scope="col" [ngStyle]="column.headerStyles">
          <ng-container>
            {{ column.display_name }}
          </ng-container>
        </th>
        } @else{
        <th scope="col" [ngStyle]="column.headerStyles">
          @if(column._config?.displayInColumn) {
          <ng-template
            *ngTemplateOutlet="
              CommonGenericFields;
              context: { $implicit: { column, row: columns, isColumn: true } }
            "
          ></ng-template>
          }
          <!-- Default column rendering -->
          <ng-container>
            {{ column.display_name }}
          </ng-container>
        </th>
        }
      </ng-container>
    </tr>
  </thead>
  <tbody>
    @for (row of displayData; track row) {
    <tr>
      <!-- Dynamically render the table rows -->
      <td
        *ngIf="options.isExpandable"
        [nzShowExpand]="row.isExpandable"
        [(nzExpand)]="row.expand"
        (nzExpandChange)="onExpandChange(row.row_id, $event)"
        style="width: 10px"
      ></td>

      <td
        *ngFor="let column of columns"
        [hidden]="column.key === 'row_expand'"
        [ngStyle]="column.cellStyles"
      >
        <ng-container [ngSwitch]="column.key">

          <!-- When column has _config and formatted text -->
          <ng-container *ngIf="column._config?.isFormatedText; else defaultColumn">
            {{ capitalizeFirstLetter(getNestedData(row, column.key)) }}
          </ng-container>

          <!-- Default column content -->
          <ng-template #defaultColumn>
            <ng-container *ngIf="column._config; else plainValue">
              <ng-template
                *ngTemplateOutlet="
                  CommonGenericFields;
                  context: { $implicit: { column, row, isColumn: false } }
                "
              ></ng-template>
            </ng-container>

            <ng-template #plainValue>
              {{ getNestedData(row, column.key) }}
            </ng-template>
          </ng-template>

        </ng-container>
      </td>
    </tr>

    <ng-container
      *ngIf="row.expandedContent?.type === 'structured' && row.expand"
    >
      <tr
        *ngFor="let item of row.expandedContent?.content"
        style="background: #eef2ff"
      >
        <td *ngFor="let column of columns" [ngStyle]="column.cellStyles">
          <ng-container *ngIf="item[column.key]; else emptyCell">
            <button class="input-btn" *ngIf="item[column.key] === 'Input'">
              {{ item[column.key] }}
            </button>
            <button class="output-btn" *ngIf="item[column.key] === 'Output'">
              {{ item[column.key] }}
            </button>

            <span
              *ngIf="
                item[column.key] !== 'Output' && item[column.key] !== 'Input'
              "
              >{{ item[column.key] }}</span
            >
          </ng-container>
          <ng-template #emptyCell></ng-template>
        </td>
      </tr>
    </ng-container>
    <ng-container
      *ngIf="row.expandedContent?.type === 'plain-text' && row.expand"
    >
      <tr>
        <span class="mx-5">{{ row.expandedContent.content }}</span>
      </tr>
    </ng-container>
    }
  </tbody>
</nz-table>

<ng-template #CommonGenericFields let-data>
  <label *ngIf="data.column._config?.label">
    {{ data.column._config?.label }}
  </label>
  <ng-container [ngSwitch]="data.column?._config?.type">
    <!-- Checkbox column header -->
    <ng-container class="table-checkbox" *ngSwitchCase="'checkbox'">
      @if(data.isColumn) {
      <input
        type="checkbox"
        [checked]="isAllChecked"
        [indeterminate]="isIndeterminate"
        (change)="onSelectAll($event)"
      />
      } @else {
      <input
        type="checkbox"
        [(ngModel)]="data.row.select"
        (ngModelChange)="onRowSelectChange($event, data.row)"
      />
      }
    </ng-container>

    <!-- Icon -->
    <ng-container *ngSwitchCase="'icon'">
      @if(data.column._config?.isCondional) {
      <ng-container
        *ngIf="
          data.column._config?.targetKey &&
            data.row[data.column._config?.targetKey];
          else noTargetKey
        "
      >
        <div class="d-flex align-items-center">
          <mat-icon
            class="d-flex align-items-center"
            [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
            [ngStyle]="
              data.column._config?.value[
                data.row[data.column._config?.targetKey].toLowerCase()
              ]?.iconStyles
            "
            (click)="emitAction(data.column._config?.type, data)"
            (keydown.enter)="emitAction(data.column._config?.type, data)"
          >
            {{
              data.column._config?.value[
                data.row[data.column._config?.targetKey].toLowerCase()
              ]?.value
            }}
          </mat-icon>
          <span *ngIf="data.column._config?.targetKey != 'download_report'">{{
            data.row[data.column.key]
          }}</span
          ><span
            *ngIf="data.column._config?.targetKey == 'download_report'"
            class="download"
            (click)="emitAction(data.column._config?.type, data)"
            (keydown.enter)="emitAction(data.column._config?.type, data)"
            >Download Report</span
          >
        </div>
      </ng-container>

      <ng-template #noTargetKey>
        <mat-icon
          [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
          [ngStyle]="
            data.column._config?.value[data.row[data.column.key]]?.iconStyles
          "
          (click)="emitAction(data.column._config?.type, data)"
          (keydown.enter)="emitAction(data.column._config?.type, data)"
        >
          {{ data.column._config?.value[data.row[data.column.key]]?.value }}
        </mat-icon>
      </ng-template>

      } @else{
      <mat-icon
        (click)="emitAction(data.column._config?.type, data)"
        (keydown.enter)="emitAction(data.column._config?.type, data)"
      >
        {{ data.column._config.value }}
      </mat-icon>
      }
    </ng-container>

    <!-- log-svg -->
    <ng-container *ngSwitchCase="'log-svg'">
      @if((data.column._config?.isCondional) &&
      data.row[data.column._config?.targetKey]?.toLowerCase() ===
      data.column._config?.condition?.toLowerCase() ) {
      <img
        (click)="emitAction(data.column._config?.type, data)"
        (keydown.enter)="emitAction(data.column._config?.type, data)"
        alt="log-svg"
        [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
        [src]="(data.column._config.value) | assetUrl"
      />
      }
    </ng-container>

    <!-- link-->
     <ng-container *ngSwitchCase="'link'">
        <a (click)="emitAction(data.column._config?.type, data)">{{ data.row[data.column.key] }}</a>
     </ng-container>

    <!-- svg -->
    <ng-container *ngSwitchCase="'svg'">
      <img
        (click)="emitAction(data.column._config?.type, data)"
        (keydown.enter)="emitAction(data.column._config?.type, data)"
        [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
        [src]="(data.column._config.value) | assetUrl"
      />
    </ng-container>

    <!-- Icon -->
    <ng-container *ngSwitchCase="'image'">
      @if(data.column._config?.isCondional) {
      <ng-container
        *ngIf="
          data.column._config?.targetKey &&
            data.row[data.column._config?.targetKey];
          else noTargetKeyImage
        "
      >
        <div class="d-flex align-items-center">
          <img
            [matTooltip]="
              data.column._config?.value[
                data.row[data.column._config?.targetKey].toLowerCase()
              ]?.tooltip
            "
            class="d-flex align-items-center"
            [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
            [ngStyle]="
              data.column._config?.value[
                data.row[data.column._config?.targetKey].toLowerCase()
              ]?.iconStyles
            "
            [src]="
              (data.column._config?.value[
                data.row[data.column._config?.targetKey].toLowerCase()
              ]?.value) | assetUrl
            "
            (click)="emitAction(data.column._config?.type, data)"
            (keydown)="emitAction(data.column._config?.type, data)"
          />

          <span [hidden]="data.column._config?.hideText">{{
            data.row[data.column.key]
          }}</span>
        </div>
      </ng-container>

      <ng-template #noTargetKeyImage>
        <img
          [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
          [ngStyle]="
            data.column._config?.value[data.row[data.column.key]]?.iconStyles
          "
          [src]="(data.column._config?.value[data.row[data.column.key]]?.value) | assetUrl"
          (click)="emitAction(data.column._config?.type, data)"
          (keydown)="emitAction(data.column._config?.type, data)"
        />
      </ng-template>

      } @else{
      <img
        (click)="emitAction(data.column._config?.type, data)"
        (keydown)="emitAction(data.column._config?.type, data)"
        [src]="(data.column._config.value) | assetUrl"
        [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
        alt="target"
        (keydown.enter)="emitAction(data.column._config?.type, data)"
      />
      }
    </ng-container>

    <!-- Copy -->
    <ng-container *ngSwitchCase="'copy'">
      <div class="copy-div">
        <span>
          {{ data.row[data.column.key] }}
        </span>
        <img
          src="assets/images/virtusa-icons/copy-outline.png"
          alt="copy"
          (click)="emitAction(data.column._config?.type, data)"
          (keydown)="emitAction(data.column._config?.type, data)"
          [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
        />
        <!-- <mat-icon
          (click)="emitAction(data.column._config?.type, data)"
          [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
        >
          {{ data.column._config.value }}
        </mat-icon> -->
      </div>
    </ng-container>

    <!-- context menu -->
    <ng-container *ngSwitchCase="'context-menu'">
      <div>
        <mat-icon
          (click)="openContextMenu(data.column._config?.type, data, $event)"
          [ngClass]="{ 'clickable-item': data.column._config?.isClickable }"
          (keydown.enter)="openContextMenu(data.column._config?.type, data, $event)"
        >
          {{ data.column._config.value }}
        </mat-icon>
        <ul
          class="context-menu-items"
          *ngIf="
            contextMenuIndex === getRowIndex(data.row) &&
            data.column._config.menu
          "
          [ngStyle]="{
            top: contextMenuPosition.y + 'px',
            left: contextMenuPosition.x + 'px'
          }"
        >
          <li
            *ngFor="let item of data.column._config.menu"
            (click)="emitAction(data.column._config?.type, data, item)"
            (keydown.enter)="emitAction(data.column._config?.type, data, item)"
          >
            <span
              class="header-12"
              (click)="handleContextMenuAction($event, data)"
              (keydown.enter)="handleContextMenuAction($any($event), data)"
              [ngClass]="{
                'text-danger': item === 'Delete',
                'text-default': item !== 'Delete'
              }"
            >
              {{ item }}
            </span>
          </li>
        </ul>
      </div>
    </ng-container>

    <!-- Button -->
    <ng-container *ngSwitchCase="'button'">
      <button
        nz-button
        [ngClass]="data.column._config.classNames"
        class="btn-blue nowrap"
        (click)="emitAction(data.column?._config?.type, data)"
      >
        {{ data.column._config.name }}
      </button>
    </ng-container>

    <!-- Conditional Button -->
    <ng-container *ngSwitchCase="'conditional-button'">
      @if((data.column?._config?.conditionalCheck &&
      data.row[data.column?._config?.conditionalCheck?.key] ===
      data.column?._config?.conditionalCheck?.value )) {
      <button
        class="nowrap"
        [ngClass]="
          data.column?._config ? data.column?._config.classNames : 'ant-btn'
        "
        (click)="emitAction(data.column._config?.type, data)"
      >
        <img
          *ngIf="data.column._config?.isImage"
          [src]="(data.column._config?.imgSrc) | assetUrl"
          class="conditional-img"
        />
        {{ data.column?._config.name }}
      </button>
      }
    </ng-container>

    <!-- Date -->
    <ng-container *ngSwitchCase="'date'">
      <span> {{ data.row[data.column.key] | customDateFormat }}</span>
    </ng-container>

    <!-- Input -->
    <ng-container *ngSwitchCase="'input'">
      <input
        class="form-control"
        [type]="data.column._config?.inputType || 'text'"
        [ngClass]="data.column._config?.classNames"
        [placeholder]="data.column._config?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.column._config?.type, data)"
      />
    </ng-container>

    <ng-container *ngSwitchCase="'select'">
      <select
        class="form-select"
        [ngClass]="data.column._config?.classNames"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.column._config?.type, data)"
      >
        <option
          [value]="item.value"
          *ngFor="let item of data.column._config?.options"
        >
          {{ item.label }}
        </option>
      </select>
    </ng-container>

    <ng-container *ngSwitchCase="'textarea'">
      <textarea
        class="form-control"
        [ngClass]="data.column._config?.classNames"
        [placeholder]="data.column._config?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.column._config?.type, data, $event)"
        (blur)="emitAction(data.column._config?.type, data, $event, 'blur')"
      >
      </textarea>
    </ng-container>

    <ng-container *ngSwitchCase="'thumb-feedback'">
      <div class="d-flex flex-row">
        <mat-icon
          *ngFor="let icon of data.column._config?.value; let i = index"
          (click)="emitAction(data.column._config?.type, data, i)"
          [ngClass]="{
            'clickable-item': data.column._config?.isClickable,
            clicked: data.row.iconClicked === i
          }"
          [ngStyle]="data.column._config?.iconStyles"
          (keydown.enter)="emitAction(data.column._config?.type, data, i)"
        >
          {{ icon }}
        </mat-icon>
      </div>

      <textarea
        *ngIf="data.row.feedbackEnabled === true"
        class="form-control"
        [ngClass]="data.column._config?.classNames"
        [placeholder]="data.column._config?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.column._config?.type, data, $event)"
        (blur)="emitAction(data.column._config?.type, data, $event, 'blur')"
      >
      </textarea>
    </ng-container>

    <ng-container *ngSwitchCase="'group'">
      <div class="row">
        <ng-container *ngFor="let field of data.column._config?.fields">
          <div [ngClass]="getGroupClassName(data.column._config?.fields)">
            <label *ngIf="field.label"> {{ field.label }} </label>
            <ng-container [ngSwitch]="field.type">
              <ng-container *ngSwitchCase="'input'">
                <input
                  class="form-control"
                  [type]="field.inputType || 'text'"
                  [ngClass]="field.classNames"
                  [placeholder]="field.placeholder || ''"
                  [(ngModel)]="field.value"
                  (change)="emitAction(field.type, data)"
                />
              </ng-container>

              <ng-container *ngSwitchCase="'select'">
                <select
                  class="form-select"
                  [ngClass]="field.classNames"
                  [(ngModel)]="field.value"
                  (change)="emitAction(field.type, data)"
                >
                  <option
                    [value]="item.value"
                    *ngFor="let item of field.options"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'io'">
      <ng-container *ngIf="data.row[data.column.key] === 'Input'">
        <button class="input-btn">{{ data.row[data.column.key] }}</button>
      </ng-container>
      <ng-container *ngIf="data.row[data.column.key] === 'Output'">
        <button class="output-btn">{{ data.row[data.column.key] }}</button>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
